import CourseLectureEventCalendar from './big-calendar/course-lecture-event-calendar';
import React, { CSSProperties } from 'react';
import globalLectureBuilderStore from '../../../../stores/global-lecture-builder-store';
import { observer } from 'mobx-react-lite';
import { LecturePageDialog } from '../lecture-page-dialog/lecture-page-dialog';

const styles = {
  header: {
    marginBottom: '8px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  } as CSSProperties,
  title: {
    color: '#041E49',
    fontSize: '20px',
    fontWeight: 'bold',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'stretch',
  } as CSSProperties,
  calendar: {
    flex: 4,
    display: 'flex',
  } as CSSProperties,
};

export const LectureCalendar = observer(() => {
  return (
    <div>
      {!!globalLectureBuilderStore.selectedLecture && <LecturePageDialog />}
      <div style={styles.container}>
        <div style={styles.calendar}>
          <CourseLectureEventCalendar />
        </div>

        {/*<div style={{ flex: 1 }}>
          <CalendarLeftPane />
        </div>*/}
      </div>
    </div>
  );
});
